import React, {Component} from 'react';
import Navigation from './components/Navigation/Navigation';
import SignIn from './components/SignIn/SignIn';
import Register from './components/Register/Register';
import Logo from './components/Logo/Logo';
import ImageLinkForm from './components/ImageLinkForm/ImageLinkForm';
import Rank from './components/Rank/Rank';
import './App.css';
import Particles from 'react-particles-js';
import FaceRecognition from './components/FaceRecognition/FaceRecognition'

const particlesOptions = {
    particles: {
      line_linked: {
        shadow: {
          enable: true,
          color: "#3CA9D1",
          blur: 5
        }
      }
    }
}

const initialState ={
  input: '',
  imageURL: '',
  box: {},
  route: 'signin',
  isSignedIn: false,
  user: {
        id: '',
        name: '', 
        email: '',
        entries: 0, 
        joined: ''
  }
}

class App extends Component {

  constructor(){
    super();
    this.state = initialState;
  }

  /*
  componentDidMount(){
    fetch('https://aqueous-tundra-89817.herokuapp.com/')
      .then(response => response.json())
      .then(console.log)
  }
  */

  loadUser = (data) => {
    console.log("Saving user: ", data)
    this.setState({user: {
      id: data.id,
      name: data.name, 
      email: data.email,
      entries: data.entries, 
      joined: data.joined
    }})
    console.log("Saved user:", this.state.user)
  }

  calculateFaceLocation = (data) => {
    
    const clarifaiFace = data.outputs[0].data.regions[0].region_info.bounding_box;
    const image = document.getElementById('inputImage');
    const width = Number(image.width);
    const height = Number(image.height);
    
    console.log(width, height);

    return{
      leftCol: clarifaiFace.left_col * width,
      topRow: clarifaiFace.top_row * height,
      rightCol: width - (clarifaiFace.right_col * width),
      bottomRow: height - (clarifaiFace.bottom_row * height)
    }

  } 

  displayFaceBox = (box) => {
    console.log(box);
    this.setState({box: box});
  }

  onInputChange = (event) => {
    this.setState({input: event.target.value});
  }

  onButtonSubmit = () => {
    this.setState({imageURL: this.state.input});
    fetch('https://aqueous-tundra-89817.herokuapp.com/imageurl', {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify({
        input: this.state.input
      })
    })
    .then(response=> response.json())
    .then( response => {
      if (response) {
        fetch('https://aqueous-tundra-89817.herokuapp.com/image', {
          method: 'put',
          headers: {'Content-type': 'application/json'},
          body: JSON.stringify({
            id: this.state.user.id
          })
        })
        .then(response => response.json())
        .then(count => {
          this.setState(Object.assign(this.state.user, {entries: count}))
        })
        .catch(console.log)
      }
      this.displayFaceBox(this.calculateFaceLocation(response))
    })
    .catch(err => console.log(err));
  }

  onRouteChange = (route) => {
    if(route === 'signout'){
      this.setState(initialState)
    }else if (route === 'home'){
      this.setState({isSignedIn: true})
    }
    this.setState({route: route});
  }

  render(){
    const {isSignedIn, imageURL, route, box} = this.state;
  return (
    <div className="App">
      <Particles className='particles'
        params={particlesOptions}
            />
        { route === 'home' 
          ? <div>
              <Navigation isSignedIn={isSignedIn} onRouteChange={this.onRouteChange}/>
              <Logo />
              <Rank name={this.state.user.name} entries={this.state.user.entries}/>
              <ImageLinkForm 
                onInputChange={this.onInputChange} 
                onButtonSubmit={this.onButtonSubmit}/>
              <FaceRecognition box = {box} imageURL = {imageURL}/>
            </div>
          : (
              route ==="signin" 
              ? 
              <div>
              <Navigation isSignedIn={isSignedIn} onRouteChange={this.onRouteChange}/>
              <SignIn loadUser={this.loadUser} onRouteChange={this.onRouteChange}/>
              </div>
              : 
              <div>
              <Navigation isSignedIn={isSignedIn} onRouteChange={this.onRouteChange}/>
              <Register loadUser = {this.loadUser} onRouteChange={this.onRouteChange}/>
              </div>
            )
        }
    </div>
  );
}
}

export default App;
